import { FC } from 'react';

import { ColSize } from '../ColSize';
import { ContentSection } from '../ContentSection';
import { RowSize } from '../RowSize';
import { Column, _renderColumns } from '../../../pages/production/InsurancePolicyDetail/utils/renderSections';

interface SectionSummaryProps {
  summaryInfo: Array<Column[]>;
}

export const SectionSummary: FC<SectionSummaryProps> = ({ summaryInfo }) => {
  return (
    <ContentSection level='h3' title='Resumen'>
      <RowSize>
        <ColSize size={100}>
          {summaryInfo.map((insured, index) => (
            <RowSize key={`${insured[0].label}-${index}`}>
              {_renderColumns(insured)}
            </RowSize>
          ))}
        </ColSize>
      </RowSize>
    </ContentSection>
  );
};
